// @ts-check
import SmrClient from "Utils/Requests/SmrClient";

class TracesRequests {
    /**
     * @returns {Promise<TracesState>}
     */
    async GetTracesState() {
        return await SmrClient.FetchJson({
            url: 'Traces/GetTracesState',
            method: "GET"
        });
    }

    /**
     * @param {string} traceKey
     * @param {boolean} val
     */
    async SetTraceKey(traceKey, val) {
        await SmrClient.FetchJson({
            url: 'Traces/SetTraceKey',
            method: "POST",
            body: { traceKey: traceKey, val: val },
            bodyIsUrlParams: true
        });
    }

    /**
     * @returns {Promise<VoidResponse>}
     */
    async SwitchTracingOn() {
        return await SmrClient.FetchJson({
            url: 'Traces/SwitchTracingOn',
            method: "POST"
        });
    }

    /**
     * @returns {Promise<VoidResponse>}
     */
    async SwitchTracingOff() {
        return await SmrClient.FetchJson({
            url: 'Traces/SwitchTracingOff',
            method: "POST"
        });
    }

    async LoadLogsFile() {
        await SmrClient.FetchDownload({
            url: 'Traces/LoadLogsFile',
            method: "GET"
        });
    }

    /**
     * @param {FrontTraceRecord[]} traces
     */
    async SaveTracesFromFront(traces) {
        await SmrClient.FetchJson({
            url: 'Traces/SaveTracesFromFront',
            method: "POST",
            body: traces
        });
    }
}

export default new TracesRequests;